import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src879763043/src/codemochi-courses/src/components/routes/public/Lecture.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div className="objective">
  <p>
    <span>Objective:</span> Create a Recipes List component which will fetch our
    list of recipes either from a recipes query or a userLikes query.
  </p>
    </div>
    <p>{`The RecipesList component will be responsible for fetching the recipes list data and iterating over the list to display a `}<inlineCode parentName="p">{`<p>`}</inlineCode>{` tag for each recipe in the list. We will swap out that `}<inlineCode parentName="p">{`<p>`}</inlineCode>{` tag for a `}<inlineCode parentName="p">{`<Recipe />`}</inlineCode>{` component in a future lecture.`}</p>
    <p>{`First, let's install lodash:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install --save lodash
`}</code></pre>
    <p>{`Lodash is the swiss army knife of array and object manipulation and we will be using it to fetch values out of our recipes return object.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-components/RecipeList.tsx"
      }}>{`import { QueryHookOptions, useQuery } from '@apollo/react-hooks';
import { recipesGraphQL } from '../graphql/queries/recipes';
import { userLikesGraphQL } from '../graphql/queries/userLikes';
import * as _ from 'lodash';
import { Row } from 'antd';
import { Recipe } from '../generated/apollo-components';

export enum queryEnum {
  userLikes = 'userLikes',
  recipes = 'recipes',
}

type RecipesListProps = {
  options?: QueryHookOptions;
  parentRoute: string;
  queryType: queryEnum;
};

export const RecipesList = ({
  options,
  parentRoute,
  queryType,
}: RecipesListProps) => {
  const query =
    queryType === queryEnum.recipes ? recipesGraphQL : userLikesGraphQL;

  const { loading, data, error } = useQuery(query, options);

  const parentArray = _.get(data, queryType);
  const recipesList = _.map(parentArray, (value) =>
    _.get(value, 'recipe', value),
  );
  console.log(data);
  console.log(parentArray);

  if (loading) return <p>Loading</p>;
  if (error) return <p>Error</p>;
  if (recipesList.length === 0) return <p>Warning</p>;

  return (
    <Row>
      {recipesList.map((recipe: Recipe) => (
        <p key={recipe.id}>{recipe.title}</p>
      ))}
    </Row>
  );
};

`}</code></pre>
    <p>{`We are using the `}<inlineCode parentName="p">{`apollo-components`}</inlineCode>{` file for our Recipe type definition. We import the recipes and userLikes queries because this list component will allow us to display either recipes or userLikes depending on which `}<inlineCode parentName="p">{`queryType`}</inlineCode>{` is specified when calling the component.`}</p>
    <p>{`Now that we have our base `}<inlineCode parentName="p">{`<RecipesList />`}</inlineCode>{` component, let's turn back to our `}<inlineCode parentName="p">{`index.tsx`}</inlineCode>{` file in our pages directory. Update the `}<inlineCode parentName="p">{`index.tsx`}</inlineCode>{` file to import the `}<inlineCode parentName="p">{`<RecipesList />`}</inlineCode>{` component and also the `}<inlineCode parentName="p">{`queryEnum`}</inlineCode>{` type.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-pages/index.tsx"
      }}>{`import styled from 'styled-components';
import { MainLayout } from '../components/layout/MainLayout';
import { RecipesList, queryEnum } from '../components/RecipesList';

const StyledHeader = styled.h1\`
  \${({ theme }) => \`
    font-size: 2em;
    text-align: left;
    padding: \${theme['padding-small']} \${theme['padding-small']};
  \`}
\`;

const Index = () => {
  return (
    <MainLayout title="Recipes">
      <StyledHeader>Index Page</StyledHeader>
      <RecipesList parentRoute="recipe" queryType={queryEnum.recipes} />
    </MainLayout>
  );
};

export default Index;

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      